module.exports = "/_next/static/images/paper-fc5e07ed2b0b992672deba3ed35109f0.svg";